import React, { useState } from "react";
import products from "../../assets/fake-data/landingpage-four/products";

const Products = () => {
  const [dataBlock] = useState({
    title: "Product Doc",
    subTitle:
      "Due to its widespread use as filler text for layouts, non-readability is of great importance.",
  });
  return (
    <>
      <section className="py-20">
        <div className="container">
          <div className="grid grid-cols-1">
            <div className="text-center">
              <h2 className="font-bold text-[32px] md:text-[40px] capitalize mb-2 relative z-10">
                <span className="bg-[#dff1f0] h-[70px] w-[70px] inline-block absolute rounded-full -z-10 -top-[15px]"></span>
                {dataBlock.title}
              </h2>
              <p className="text-muted mx-auto text-lg max-w-[600px] mt-6">
                {dataBlock.subTitle}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] mt-16">
            {products.map((x) => {
              return (
                <div key={x.id}>
                  <img src={x.img} alt="ss" className="mx-auto block rounded" />
                  <div className="py-6">
                    <div className="flex items-center gap-3">
                      <div className="shrink-0 h-12 w-12 leading-[48px] bg-custom/[17%] rounded-full text-center text-2xl">
                        <i className={` ${x.icon} text-custom`}></i>
                      </div>
                      <h5 className="font-bold text-xl">{x.title}</h5>
                    </div>
                    <p className="text-muted mt-6">{x.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
